import {BASE_URL} from '../../configuration/apiconfig';
import UserStore from '../../store/UserStore';
export default class OrderService{
    key =localStorage.getItem('apiKey')
    async getOrderHistory(start = 0 ,length = 10){
        const response = await fetch(`${BASE_URL}order/order_history?start=${start}&length=${length}`, {     //url
            method: 'GET',                 //method
            headers : {                     //passing header 
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json',
                'api-key'       : this.key,
                'access-token'  : UserStore.key
            }
        })
        return await response.json();
    }

    async getPerformanceReport(start = 0 ,length = 10 ,startDate ,endDate){
        const response = await fetch(`${BASE_URL}order/performance-report?start=${start}&length=${length}&startDate=${startDate}&endDate=${endDate}`, {     //url
            method: 'GET',                 //method
            headers : {                     //passing header 
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json',
                'api-key'       : this.key,
                'access-token'  : UserStore.key
            }
        })
        return await response.json();
    }
    async getSponsorReport(start = 0 ,length = 10 ,startDate ,endDate){
        const response = await fetch(`${BASE_URL}order/sponsor-report?start=${start}&length=${length}&startDate=${startDate}&endDate=${endDate}`, {     //url
            method: 'GET',                 //method
            headers : {                     //passing header 
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json',
                'api-key'       : this.key,
                'access-token'  : UserStore.key
            }
        })
        return await response.json();
    }
}

